import * as StripeTypes from "./stripeTypes";
import { IBaseInitialSettings } from "../../../Common/baseInitialSettings";
import { ICustomProfileFieldOption, ILookupItem } from "common.ui/CustomForms/Editor/DataTypes/IStore";
import { CountryCode } from "common.ui/CustomForms/Editor/DataTypes/dataTypes";

export enum FormState {
    Dirty,
    Saved,
    Saving,
}

export enum LockStatus {
    Locked = 0,
    Draft = 1, // manual draft status
    AutoDraft = 2, // auto save draft status
}

export interface ICompositionParams {
    templateId: number;
    customFormId: number;
    composition: any;
    drawingsAvailable: any;
    formType: number;
    status: LockStatus;
    defaultMode: any;
    isPortalCustomFormView?: boolean;
    displayModes?: boolean;
    callbacks?: any;
    onContentChange?: () => void;
    uploadClientFilesUrl: string;
    removeClientFile(fileId: number);
    getUploadError?(responseText: string, response: unknown): Error;
    onRemoveClientFile?(): void;
    onClientFileAdded?();
    showErrorToUser?(message: string);
    showStripeModal?(sectionId: number, fieldId: number): void;
    clientFileMaxNumber: number;
    clientFileMaxSize: number;
    lookups: Map<string, ILookupItem[]>;
    customLookups: Map<string, ILookupItem[]>;
    customProfileFields?: ICustomProfileFieldOption[];
    sgCountryCode: CountryCode;
    bsDateFormat: string;
    bsWeekStart: number;
    shortDateFormat: string;
}

export enum AuthenticationMethod {
    None,
    Email,
    MobileNumber,
    DateOfBirth,
}

export interface IInitialSettings extends IBaseInitialSettings {
    compositionParams: ICompositionParams;
    saveFormUrl: string;
    sgName: string;
    formName: string;
    dateFormat: string;
    removeClientFileUrl: string;

    authenticationSuccessful: boolean;
    authenticationRequired: boolean;
    authenticationMethod: AuthenticationMethod;
    authenticationErrorMessage: string;
    cultureDateFormat: string;
    encryptTokenUrl: string;
    clientStripeAccount: string;
    practitionerId: number;
    setupSCACardUrl: string;
    formsPageUrl: string;
    redirectToFormsPage: boolean;
}

export interface IGridInitialSettings {
    forms: ICustomForm[];
    downloadUrl: string;
    downloadPdfUrl: string;
    viewUrl: string;
    homeUrl: string;
    isGotenbergPrintEnabled: boolean;
}

export interface ICommon {
    formState?: FormState;
    status: LockStatus;
    composition: any;
    isBusy?: boolean;
    submitRequested?: boolean;
}

export interface IStore {
    initialSettings: IInitialSettings;
    common: ICommon;
    stripe: StripeTypes.IStripe;
    stripeForm: any;
}

export interface IStoreCustomFormGrid {
    initialSettings: IGridInitialSettings;
}

export interface ICustomForm {
    customFormDataNumber: number;
    formName: string;
    formStatus: string;
    dateCompleted?: string;
    expiryDate?: string;
    isExpired: boolean;
}
